import { Response } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { WsreOverview, WsreSummary, ArrivalPhotoOverview, Photo, ComponentTabRecord, CrackTestTab, DipTest, DipTestConditionType, SaveNewPhotoOnComponentWSREModelRequest, SaveNewPhotoOnDipTestWSREModelRequest, IdlerPartImageReqVM, CreateDipTestsVM, SaveNewPhotoFrameWSREModelRequest, componentTabFrames, WSREFrameComponentsRecordsVM, ComponentCrackImagesFrame, ComponentFrameComment, MeasurementCrackImagesFrame, WSREActionHistoryVM, PagedResult } from './models/wsre.model';
import { Tuple } from '../../entities/global/model';
import { catchError } from 'rxjs/operators';
import { ComponentImageListVm, ComponentImages, SystemModel, UpdateComponentMeasurementModel, UpdateTrackFrameConfigurationRequest, UpdateTrackFrameConfigurationResponse } from '../interpretation/models/interpretation.model';
import { WSREFrameComponentDocumnetVM } from '../GET_NEW_UI/setup-implement/setup-implement.model';
import { AddWSREFrameComponentPhotoModel} from '../../modules/interpretation/models/interpretation.model';

@Injectable()
export class WsreService {
  private readonly API_BASE = 'api/wsre/';
  private readonly REPAIR_ESTIMATE_OVERVIEW = this.API_BASE + 'GetRepairEstimateOverview';
  private readonly REPAIR_ESTIMATE_OVERVIEW_FRAME = this.API_BASE + 'GetRepairEstimateOverviewFrame';
  private readonly REPAIR_ESTIMATE_SUMMARY = this.API_BASE + 'GetRepairEstimateSummary';
  private readonly REPAIR_ESTIMATE_SUMMARY_FRAME_RIGHT_SIDE = this.API_BASE + 'GetRepairEstimateSummaryFrameRightSide';
  private readonly ARRIVAL_PHOTOS_OVERVIEW = this.API_BASE + 'GetArrivalPhotosOverview';
  private readonly ARRIVAL_PHOTOS_OVERVIEW_FRAME = this.API_BASE + 'GetArrivalPhotosOverviewFrame';
  private readonly COMPONENT_TAB_DATA = this.API_BASE + 'GetComponentTabData';
  private readonly COMPONENT_TAB_DATA_FRAMES = this.API_BASE + 'GetComponentTabDataFrames';
  private readonly COMPONENT_TAB_DATA_FRAMES_LEFT_RIGHT = this.API_BASE + 'GetComponentTabDataFramesLeftAndRight';

  private readonly CRACK_TEST_TAB = this.API_BASE + 'GetCrackTestTab';
  private readonly DIP_TESTS = this.API_BASE + 'GetDipTests';
  private readonly CHECK_ACCESS_TO_INSPECTION = this.API_BASE + 'CheckAccessToInspection';
  private readonly GET_PHOTO = this.API_BASE + 'GetPhoto';
  private readonly GET_IDLER_CHILD_PHOTO = this.API_BASE + 'GET_IDLER_CHILD_PHOTO';
  private readonly DELETE_PHOTO = this.API_BASE + 'DeletePhoto';
  private readonly DELETE_IDLER_CHILD_PHOTO = this.API_BASE + 'deleteIdlerPartPhoto';

  private readonly USER_CAN_EDIT = this.API_BASE + 'CheckUserCanEdit';
  private readonly UPDATE_COMPONENT_RECORD_COMMENT = this.API_BASE + 'UpdateComponentRecordComment';
  private readonly UPDATE_COMPONENT_RECORD_MEASUREMENT = this.API_BASE + 'UpdateComponentRecordMeasurement';
  private readonly UPDATE_CHILD_COMPONENT_RECORD_MEASUREMENT = this.API_BASE + 'UpdateChildComponentRecordMeasurement';

  private readonly UPDATE_CRACK_TEST_EVAL = this.API_BASE + 'UpdateCrackTestEval';
  private readonly UPDATE_CRACK_TEST_COMMENT = this.API_BASE + 'UpdateCrackTestComment';
  private readonly UPDATE_DIP_TEST_LEVEL = this.API_BASE + 'UpdateDipTestLevel';
  private readonly UPDATE_DIP_TEST_COMMENT = this.API_BASE + 'UpdateDipTestComment';
  private readonly UPDATE_DIP_TEST_RECOMMENDATION = this.API_BASE + 'UpdateDipTestRecommendation';
  private readonly UPDATE_DIP_TEST_CONDITION = this.API_BASE + 'UpdateDipTestCondition';
  private readonly GET_POSSIBLE_DIP_TEST_CONDITION_TYPES = this.API_BASE + 'GetPossibleDipTestConditionTypes';
  private readonly UPDATE_OVERALL_SUMMARY_COMMENT = this.API_BASE + 'UpdateOverallSummaryComment';
  private readonly UPDATE_OVERALL_SUMMARY_COMMENT_RIGHT = this.API_BASE + 'UpdateOverallSummaryCommentRightFrame';
  private readonly UPDATE_FRAME_CONFIGUARTION = this.API_BASE + 'UpdateWSREFrameConfiguration';

  private readonly UPDATE_OVERALL_SUMMARY_RECOMMENDATION = this.API_BASE + 'UpdateOverallSummaryRecommendation';
  private readonly UPDATE_OVERALL_SUMMARY_RECOMMENDATION_RIGHT = this.API_BASE + 'UpdateOverallSummaryRecommendationRightFrame';
  private readonly UPDATE_OVERALL_EVAL = this.API_BASE + 'UpdateOverallEval';
  private readonly UPDATE_OVERALL_EVAL_FRAME_RIGHT = this.API_BASE + 'UpdateOverallEvalFrame_R';
  private readonly GET_USER_UOM = this.API_BASE + 'GetUserUOM';

  private readonly UPDATE_OVERALL_FRAME_COMPONENT_COMMENT = this.API_BASE + 'UpdateOveralFrameComponentComment';



  private readonly POST_DIPTEST_IMAGE = this.API_BASE + 'SaveNewDipTestImage';
  private readonly POST_ARRIVAL_IMAGE = this.API_BASE + 'SaveArrivalPhoto';
  private readonly POST_ARRIVAL_IMAGE_FRAME = this.API_BASE + 'SaveArrivalPhotoFrame';
  private readonly POST_SaveFinalPhoto = this.API_BASE + 'SaveFinalPhoto';
  private readonly POST_SaveFinalPhoto_FRAME = this.API_BASE + 'SaveFinalPhotoFrame';
  private readonly POST_CUSTOMER_REFERENCE_IMAGE = this.API_BASE + 'SaveCustomerReferencePhotos';
  private readonly POST_CUSTOMER_REFERENCE_IMAGE_FRAME = this.API_BASE + 'SaveCustomerReferencePhotosFrame';
  private readonly POST_OLD_TAG_IMAGE = this.API_BASE + 'SaveOldTagPhotos';
  private readonly POST_OLD_TAG_IMAGE_FAME = this.API_BASE + 'SaveOldTagPhotosFrame';
  private readonly POST_FAILED_IRON_IMAGE_FAME = this.API_BASE + 'SaveFailedIronPhotosFrame';

  private readonly POST_CRACK_TEST_IMAGE = this.API_BASE + 'SaveCrackTestImage';

  private readonly POST_SaveIdlerPartImages = this.API_BASE + 'SaveIdlerPartImages';


  private readonly POST_COMPONENT_IMAGE = this.API_BASE + 'SaveNewComponentImage';
  private readonly WSRE_REPORT_SEND = this.API_BASE + 'SendReport';
  private readonly Create_Dip_Tests = this.API_BASE + 'CreateDipTests';
  private readonly POST_WSRE_FRAME_COMP_IMAGE_FAME = this.API_BASE + 'SaveComponetFrameImage';
  private readonly POST_WSRE_FRAME_COMP_IMAGE_API = this.API_BASE + 'SaveUpdateFrameComponentImage';

  constructor(private _http: HttpClient) { }

  public getUserUOM(): Observable<string> {
    return this._http.get<string>(this.GET_USER_UOM).pipe(catchError(this.handleError));
  }

  public getPossibleDipTestConditionTypes(): Observable<DipTestConditionType[]> {
    return this._http.get<DipTestConditionType[]>(this.GET_POSSIBLE_DIP_TEST_CONDITION_TYPES).pipe(catchError(this.handleError));
  }

  public updateOverallEval(wsreId: number, overallEval: string, screenId: number): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString()).set('overallEval', overallEval).set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_OVERALL_EVAL, options).pipe(catchError(this.handleError));
  }

  public updateOverallSummaryComment(wsreId: number, comment: string, screenId: number): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString()).set('comment', comment).set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_OVERALL_SUMMARY_COMMENT, options).pipe(catchError(this.handleError));
  }

  public updateOverallSummaryRecommendation(wsreId: number, recommendation: string, screenId: number): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString()).set('recommendation', recommendation).set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_OVERALL_SUMMARY_RECOMMENDATION, options).pipe(catchError(this.handleError));
  }

  public updateDipTestLevel(dipTestId: number, level: number, screenId: number): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('id', dipTestId.toString()).set('level', level.toString()).set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_DIP_TEST_LEVEL, options).pipe(catchError(this.handleError));
  }

  public updateDipTestComment(dipTestId: number, comment: string, screenId: number): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('id', dipTestId.toString()).set('comment', comment).set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_DIP_TEST_COMMENT, options).pipe(catchError(this.handleError));
  }

  public updateDipTestRecommendation(dipTestId: number, recommendation: string, screenId: number): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('id', dipTestId.toString()).set('recommendation', recommendation).set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_DIP_TEST_RECOMMENDATION, options).pipe(catchError(this.handleError));
  }

  public updateDipTestCondition(dipTestId: number, conditionId: number, screenId: number): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('id', dipTestId.toString()).set('conditionId', conditionId.toString()).set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_DIP_TEST_CONDITION, options).pipe(catchError(this.handleError));
  }

  public updateCrackTestComment(wsreId: number, newComment: string): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString()).set('newComment', newComment)
    };
    return this._http.get<Tuple>(this.UPDATE_CRACK_TEST_COMMENT, options).pipe(catchError(this.handleError));
  }

  public updateCrackTestEval(wsreId: number, testPassed: boolean): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString()).set('testPassed', testPassed.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_CRACK_TEST_EVAL, options).pipe(catchError(this.handleError));
  }

  public updateComponentRecordMeasurement(recordId: number, newMeasurement: number, toolId: number, screenId: number): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('id', recordId.toString()).set('newMeasurement', newMeasurement.toString()).set('toolId', toolId.toString()).set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_COMPONENT_RECORD_MEASUREMENT, options).pipe(catchError(this.handleError));
  }

  public updateChildComponentRecordMeasurement(recordId: number, newMeasurement: string, childId: number, screenId: number): Observable<Tuple> {
    let options = {
      params: new HttpParams()
        .set('id', recordId.toString())
        .set('newMeasurement', newMeasurement)
        .set('childId', childId.toString())
        .set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_CHILD_COMPONENT_RECORD_MEASUREMENT, options).pipe(catchError(this.handleError));
  }



  public updateComponentRecordComment(recordId: number, newComment: string, screenId: number): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('id', recordId.toString()).set('newComment', newComment.toString()).set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_COMPONENT_RECORD_COMMENT, options).pipe(catchError(this.handleError));
  }

  public checkUserCanEdit(wsreId: number): Observable<boolean> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString())
    };
    return this._http.get<boolean>(this.USER_CAN_EDIT, options).pipe(catchError(this.handleError));
  }

  public getPhoto(photoId: number, photoType: string): Observable<Photo> {
    let options = {
      params: new HttpParams().set('photoId', photoId.toString()).set('photoType', photoType)
    };
    return this._http.get<Photo>(this.GET_PHOTO, options).pipe(catchError(this.handleError));
  }

  public getIdlerPartPhoto(photoId: number, photoType: string, childId: number): Observable<Photo> {
    let options = {
      params: new HttpParams().set('photoId', photoId.toString()).set('photoType', photoType).set('childId', childId.toString())
    };
    return this._http.get<Photo>(this.GET_IDLER_CHILD_PHOTO, options).pipe(catchError(this.handleError));
  }


  public deletePhoto(photoId: number, photoType: string, screenId: number): Observable<boolean> {
    let options = {
      params: new HttpParams().set('photoId', photoId.toString()).set('photoType', photoType).set('screenId', screenId.toString())
    };
    return this._http.get<boolean>(this.DELETE_PHOTO, options).pipe(catchError(this.handleError));
  }

  public deleteIdlerPartPhoto(photoId: number): Observable<boolean> {
    let options = {
      params: new HttpParams().set('photoId', photoId.toString())
    };
    return this._http.get<boolean>(this.DELETE_IDLER_CHILD_PHOTO, options).pipe(catchError(this.handleError));
  }



  public getCrackTestTab(wsreId: number): Observable<CrackTestTab> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString())
    };
    return this._http.get<CrackTestTab>(this.CRACK_TEST_TAB, options).pipe(catchError(this.handleError));
  }

  public getDipTests(wsreId: number): Observable<DipTest[]> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString())
    };
    return this._http.get<DipTest[]>(this.DIP_TESTS, options).pipe(catchError(this.handleError));
  }

  public getComponentTabData(wsreId: number): Observable<ComponentTabRecord[]> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString())
    };
    return this._http.get<ComponentTabRecord[]>(this.COMPONENT_TAB_DATA, options).pipe(catchError(this.handleError));
  }

  public getArrivalPhotosOverview(wsreId: number): Observable<ArrivalPhotoOverview[]> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString())
    };
    return this._http.get<ArrivalPhotoOverview[]>(this.ARRIVAL_PHOTOS_OVERVIEW, options).pipe(catchError(this.handleError));
  }

  public checkAccessToInspection(wsreId: number): Observable<boolean> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString())
    };
    return this._http.get<boolean>(this.CHECK_ACCESS_TO_INSPECTION, options).pipe(catchError(this.handleError));
  }

  public getRepairEstimateOverview(wsreId: number): Observable<WsreOverview> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString())
    };
    return this._http.get<WsreOverview>(this.REPAIR_ESTIMATE_OVERVIEW, options).pipe(catchError(this.handleError));
  }

  public getRepairEstimateSummary(wsreId: number): Observable<WsreSummary> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString())
    };
    return this._http.get<WsreSummary>(this.REPAIR_ESTIMATE_SUMMARY, options).pipe(catchError(this.handleError));
  }
  public CreateDipTests(request: CreateDipTestsVM): Observable<boolean> {
    return this._http.post<boolean>(this.Create_Dip_Tests, request).pipe(catchError(this.handleError));
  }



  public SavePhotoToComponentRecord(request: SaveNewPhotoOnComponentWSREModelRequest): Observable<number> {
    return this._http.post<number>(this.POST_COMPONENT_IMAGE, request).pipe(catchError(this.handleError));
  }

  public SavePhotoToDipTestRecord(request: SaveNewPhotoOnDipTestWSREModelRequest): Observable<number> {
    return this._http.post<number>(this.POST_DIPTEST_IMAGE, request).pipe(catchError(this.handleError));
  }

  public SaveArrivalPhoto(request: SaveNewPhotoOnDipTestWSREModelRequest): Observable<number> {
    return this._http.post<number>(this.POST_ARRIVAL_IMAGE, request).pipe(catchError(this.handleError));
  }

  public SaveFinalPhoto(request: SaveNewPhotoOnDipTestWSREModelRequest): Observable<number> {
    return this._http.post<number>(this.POST_SaveFinalPhoto, request).pipe(catchError(this.handleError));
  }


  public SaveCustomerReferencePhotos(request: SaveNewPhotoOnDipTestWSREModelRequest): Observable<number> {
    return this._http.post<number>(this.POST_CUSTOMER_REFERENCE_IMAGE, request).pipe(catchError(this.handleError));
  }

  public SaveOldTagPhotos(request: SaveNewPhotoOnDipTestWSREModelRequest): Observable<number> {
    return this._http.post<number>(this.POST_OLD_TAG_IMAGE, request).pipe(catchError(this.handleError));
  }

  public SaveCrackTestImage(request: SaveNewPhotoOnDipTestWSREModelRequest): Observable<number> {
    return this._http.post<number>(this.POST_CRACK_TEST_IMAGE, request).pipe(catchError(this.handleError));
  }

  public SaveIdlerPartImages(request: IdlerPartImageReqVM): Observable<number> {
    return this._http.post<number>(this.POST_SaveIdlerPartImages, request).pipe(catchError(this.handleError));
  }

  public SendReport(WSREInspectionID: number, sendToAddress: string, customerName: string, type: number): Observable<boolean> {
    let options = {
      params: new HttpParams().set('WSREInspectionID', WSREInspectionID.toString()).set('sendToAddress', sendToAddress).set('sendToUserName', customerName)
        .set('type', type.toString())
    };
    return this._http.get<boolean>(this.WSRE_REPORT_SEND, options).pipe(catchError(this.handleError));
  }

  public GetRepairEstimateOverviewFrame(wsreId: number): Observable<WsreOverview> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString())
    };
    return this._http.get<WsreOverview>(this.REPAIR_ESTIMATE_OVERVIEW_FRAME, options).pipe(catchError(this.handleError));
  }

  public updateOverallSummaryCommentRightSide(wsreId: number, comment: string, screenId: number): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString()).set('comment', comment).set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_OVERALL_SUMMARY_COMMENT_RIGHT, options).pipe(catchError(this.handleError));
  }



  public updateWSREFrameConfiguration(wsreId: number, value: number): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString()).set('value', value.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_FRAME_CONFIGUARTION, options).pipe(catchError(this.handleError));
  }


  public updateOverallSummaryRecommendationRightSide(wsreId: number, recommendation: string, screenId: number): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString()).set('recommendation', recommendation).set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_OVERALL_SUMMARY_RECOMMENDATION_RIGHT, options).pipe(catchError(this.handleError));
  }

  public updateOverallFrameComponentComment(wsreId: number, Comment: string, Side: number, screenId: number): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString()).set('Comment', Comment).set('Side', Side.toString()).set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_OVERALL_FRAME_COMPONENT_COMMENT, options).pipe(catchError(this.handleError));
  }
  public GetRepairEstimateSummaryFrameRightSide(wsreId: number): Observable<WsreSummary> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString())
    };
    return this._http.get<WsreSummary>(this.REPAIR_ESTIMATE_SUMMARY_FRAME_RIGHT_SIDE, options).pipe(catchError(this.handleError));
  }


  public UpdateOverallEvalFrame_R(wsreId: number, overallEval: string, screenId: number): Observable<Tuple> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString()).set('overallEval', overallEval).set('screenId', screenId.toString())
    };
    return this._http.get<Tuple>(this.UPDATE_OVERALL_EVAL_FRAME_RIGHT, options).pipe(catchError(this.handleError));
  }

  public getArrivalPhotosOverviewFrame(wsreId: number): Observable<ArrivalPhotoOverview[]> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString())
    };
    return this._http.get<ArrivalPhotoOverview[]>(this.ARRIVAL_PHOTOS_OVERVIEW_FRAME, options).pipe(catchError(this.handleError));
  }

  //left side
  public SaveArrivalPhotoFrame(request: SaveNewPhotoFrameWSREModelRequest): Observable<number> {
    return this._http.post<number>(this.POST_ARRIVAL_IMAGE_FRAME, request).pipe(catchError(this.handleError));
  }



  public UpdateIsMainPhotoFrame(imageID: number, WSREId: number, type: number, side: number, ScreenId: number): Observable<boolean> {
    let options = {
      params: new HttpParams().set('imageID', imageID.toString())
        .set('WSREId', WSREId.toString())
        .set('type', type.toString())
        .set('side', side.toString())
        .set('ScreenId', ScreenId.toString())
    };
    return this._http.get<boolean>("api/WSRE/UpdateIsMainPhotoFrame", options).pipe(catchError(this.handleError));
  }

  public UpdateIncludeReortPhotoFrame(imageID: number, WSREId: number, type: number, side: number, IncludeReport: boolean, ScreenId: number): Observable<boolean> {
    let options = {
      params: new HttpParams().set('imageID', imageID.toString())
        .set('WSREId', WSREId.toString())
        .set('type', type.toString())
        .set('side', side.toString())
        .set('IncludeReport', "" + IncludeReport)
        .set('ScreenId', ScreenId.toString())
    };
    return this._http.get<boolean>("api/WSRE/UpdateIncludeReortPhotoFrame", options).pipe(catchError(this.handleError));
  }


  public SaveFinalPhotoFrame(request: SaveNewPhotoFrameWSREModelRequest): Observable<number> {
    return this._http.post<number>(this.POST_SaveFinalPhoto_FRAME, request).pipe(catchError(this.handleError));
  }

  public SaveCustomerReferencePhotosFrame(request: SaveNewPhotoFrameWSREModelRequest): Observable<number> {
    return this._http.post<number>(this.POST_CUSTOMER_REFERENCE_IMAGE_FRAME, request).pipe(catchError(this.handleError));
  }

  public SaveOldTagPhotosFrame(request: SaveNewPhotoFrameWSREModelRequest): Observable<number> {
    return this._http.post<number>(this.POST_OLD_TAG_IMAGE_FAME, request).pipe(catchError(this.handleError));
  }

  public SaveFailedIronPhotosFrame(request: SaveNewPhotoFrameWSREModelRequest): Observable<number> {
    return this._http.post<number>(this.POST_FAILED_IRON_IMAGE_FAME, request).pipe(catchError(this.handleError));
  }

  public SaveComponentPhotoWSREFrame(request: SaveNewPhotoFrameWSREModelRequest): Observable<number> {
    return this._http.post<number>(this.POST_WSRE_FRAME_COMP_IMAGE_FAME, request).pipe(catchError(this.handleError));
  }

  public SaveUpdateFrameComponentImage(request: SaveNewPhotoFrameWSREModelRequest): Observable<number> {
    return this._http.post<number>(this.POST_WSRE_FRAME_COMP_IMAGE_API, request).pipe(catchError(this.handleError));
  }
  //right side
  // public SaveArrivalPhotoFrame_R(request: SaveNewPhotoFrameWSREModelRequest): Observable<number> {
  //   return this._http.post(this.POST_ARRIVAL_IMAGE_FRAME, request).pipe(catchError(this.handleError));
  // }
  // public SaveFinalPhotoFrame_R(request: SaveNewPhotoFrameWSREModelRequest): Observable<number> {
  //   return this._http.post(this.POST_SaveFinalPhoto_FRAME, request).pipe(catchError(this.handleError));
  // }

  // public SaveCustomerReferencePhotosFrame_R(request: SaveNewPhotoFrameWSREModelRequest): Observable<number> {
  //   return this._http.post(this.POST_CUSTOMER_REFERENCE_IMAGE, request).pipe(catchError(this.handleError));
  // }

  // public SaveOldTagPhotosFrame_R(request: SaveNewPhotoFrameWSREModelRequest): Observable<number> {
  //   return this._http.post(this.POST_OLD_TAG_IMAGE, request).pipe(catchError(this.handleError));
  // }


  public GetComponentTabDataFrames(wsreId: number, customername:string): Observable<componentTabFrames[]> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString()).set('customer', customername.toString())
    };
    return this._http.get<componentTabFrames[]>(this.COMPONENT_TAB_DATA_FRAMES, options).pipe(catchError(this.handleError));
  }

  public GetComponentTabDataFramesLeftAndRight(wsreId: number): Observable<SystemModel[]> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString())
    };
    return this._http.get<SystemModel[]>(this.COMPONENT_TAB_DATA_FRAMES_LEFT_RIGHT, options).pipe(catchError(this.handleError));
  }

  public WSREUpdateVisibityOfFrameComponents(InspectionDetailId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('InspectionDetailId', InspectionDetailId.toString())
    };
    return this._http.get<Tuple>("api/WSRE/WSREUpdateVisibityOfFrameComponents", options).pipe(catchError(this.handleError));
  }

  public UpdateComponentRecordMeasurementFrameLeft(request: WSREFrameComponentsRecordsVM): Observable<boolean> {
    return this._http.post<boolean>("api/WSRE/UpdateComponentRecordMeasurementFrameLeft", request).pipe(catchError(this.handleError));
  }

  public UpdateComponentRecordMeasurementFrameRight(request: WSREFrameComponentsRecordsVM): Observable<boolean> {
    return this._http.post<boolean>("api/WSRE/UpdateComponentRecordMeasurementFrameRight", request).pipe(catchError(this.handleError));
  }

  public UpdateComponentFinalRecordMeasurementFrameRight(request: WSREFrameComponentsRecordsVM): Observable<boolean> {
    return this._http.post<boolean>("api/WSRE/UpdateComponentFinalRecordMeasurementFrameRight", request).pipe(catchError(this.handleError));
  }


  public UpdateComponentFinalRecordMeasurementFrameLeft(request: WSREFrameComponentsRecordsVM): Observable<boolean> {
    return this._http.post<boolean>("api/WSRE/UpdateComponentFinalRecordMeasurementFrameLeft", request).pipe(catchError(this.handleError));
  }

  public saveComponentMeasurementPhotoFrame(request: ComponentCrackImagesFrame): Observable<number> {
    return this._http.post<number>("api/WSRE/saveComponentMeasurementPhotoFrame", request).pipe(catchError(this.handleError));
  }

  public GetComponentCrackPhotoFrame(wsreId: number): Observable<ComponentCrackImagesFrame[]> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString())

    };
    return this._http.get<ComponentCrackImagesFrame[]>("api/WSRE/GetComponentCrackPhotoFrame", options).pipe(catchError(this.handleError));
  }

  public saveComponentCommentFrame(request: ComponentFrameComment): Observable<number> {
    return this._http.post<number>("api/WSRE/saveComponentCommentFrame", request).pipe(catchError(this.handleError));
  }

  public saveFrameComponentDocument(request: WSREFrameComponentDocumnetVM): Observable<number> {
    return this._http.post<number>("api/WSRE/saveFrameComponentDocument", request).pipe(catchError(this.handleError));
  }
  public GetComponentFrameComment(wsreId: number): Observable<ComponentFrameComment[]> {
    let options = {
      params: new HttpParams().set('wsreId', wsreId.toString())

    };
    return this._http.get<ComponentFrameComment[]>("api/WSRE/GetComponentFrameComment", options).pipe(catchError(this.handleError));
  }


  // public GetComponentImageFrame(Id: number): Observable<WSREMeasurementPointsImage[]> {
  //   let options = {
  //     params: new HttpParams().set('Id', Id.toString())
  //   };
  //   return this._http.get("api/WSRE/GetComponentImageFrame", options).pipe(catchError(this.handleError));
  // }
  public AddCrackNameCommentFrame(WSREInsoectionID: number, frameCrackRecordID: number, WSREMeasurementPointId: number, name: string, comment: string, side: number,CrackLength :number): Observable<boolean> {
    let options = {
      params: new HttpParams().set('WSREInsoectionID', WSREInsoectionID.toString())
        .set('frameCrackRecordID', frameCrackRecordID.toString())
        .set('WSREMeasurementPointId', WSREMeasurementPointId.toString())
        .set('name', "" + name)
        .set('comment', "" + comment)
        .set('side', "" + side)
        .set('CrackLength', "" + CrackLength)
    };
    return this._http.get<boolean>("api/WSRE/AddCrackNameCommentFrame", options).pipe(catchError(this.handleError));
  }

  public UpdateCrackNameFrame(WSREInsoectionID: number, frameCrackRecordID: number, WSREMeasurementPointId: number, name: string, side: number, screenId: number): Observable<boolean> {
    let options = {
      params: new HttpParams().set('WSREInsoectionID', WSREInsoectionID.toString())
        .set('frameCrackRecordID', frameCrackRecordID.toString())
        .set('WSREMeasurementPointId', WSREMeasurementPointId.toString())
        .set('name', "" + name)
        .set('side', "" + side)
        .set('ScreenId', screenId.toString())
        //.set('CrackLength', "" + CrackLength)
    };
    return this._http.get<boolean>("api/WSRE/UpdateCrackNameFrame", options).pipe(catchError(this.handleError));
  }
  public UpdateCrackLength(WSREInsoectionID: number, frameCrackRecordID: number, WSREMeasurementPointId: number, CrackLength: number, side: number, screenId: number): Observable<boolean> {
    let options = {
      params: new HttpParams().set('WSREInsoectionID', WSREInsoectionID.toString())
        .set('frameCrackRecordID', frameCrackRecordID.toString())
        .set('WSREMeasurementPointId', WSREMeasurementPointId.toString())
        .set('CrackLength', "" + CrackLength)
        .set('side', "" + side)
        .set('ScreenId', screenId.toString())
    };
    return this._http.get<boolean>("api/WSRE/UpdateCrackLength", options).pipe(catchError(this.handleError));
  }

  public UpdateCrackCommentFrame(WSREInsoectionID: number, frameCrackRecordID: number, WSREMeasurementPointId: number, comment: string, side: number, screenId: number): Observable<boolean> {
    let options = {
      params: new HttpParams().set('WSREInsoectionID', WSREInsoectionID.toString())
        .set('frameCrackRecordID', frameCrackRecordID.toString())
        .set('WSREMeasurementPointId', WSREMeasurementPointId.toString())
        .set('comment', "" + comment)
        .set('side', "" + side)
        .set('ScreenId', screenId.toString())
    };
    return this._http.get<boolean>("api/WSRE/UpdateCrackCommentFrame", options).pipe(catchError(this.handleError));
  }


  public saveCrackPhotoFrame(request: MeasurementCrackImagesFrame,isFinalCrackImag :number): Observable<boolean> {
    request.isFinalCrackImag = isFinalCrackImag;
    return this._http.post<boolean>("api/WSRE/saveCrackPhotoFrame", request).pipe(catchError(this.handleError));
  }

  public GetComponentFramePhoto(photoId: number, photoType: string): Observable<Photo> {
    let options = {
      params: new HttpParams().set('photoId', photoId.toString()).set('photoType', photoType)
    };
    return this._http.get<Photo>("api/WSRE/GetComponentFramePhoto", options).pipe(catchError(this.handleError));
  }

  public DeleteComponentframePhoto(photoId: number, photoType: string): Observable<boolean> {
    let options = {
      params: new HttpParams().set('photoId', photoId.toString()).set('photoType', photoType)
    };
    return this._http.get<boolean>("api/WSRE/DeleteComponentframePhoto", options).pipe(catchError(this.handleError));
  }


  public UpdateWSREFrameComponentMeasurement(m: UpdateComponentMeasurementModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/WSRE/UpdateWSREFrameComponentMeasurement', m).pipe(catchError(this.handleError));
  }

  public getComponentPhotoListWSREFrame(inspectionDetailId: number, inspectionId: number): Observable<ComponentImages[]> {
    const options = {
      params: new HttpParams().set('inspectionDetailId', inspectionDetailId.toString()).set('inspectionId', inspectionId.toString())
    };
    return this._http.get<ComponentImages[]>('api/WSRE/getcomponentphotoListWSREFrame', options).pipe(catchError(this.handleError));
  }
  public getObspointPhotoListWSREFrame(inspectionDetailId: number, inspectionId: number, Side: number, MeasurementPointId: number, IsFinalMeasurementImg:boolean): Observable<ComponentImageListVm> {
    const options = {
      params: new HttpParams().set('inspectionDetailId', inspectionDetailId.toString()).set('inspectionId', inspectionId.toString())
        .set('Side', Side.toString()).set('MeasurementPointId', MeasurementPointId.toString()).set('IsFinalMeasurementImg', IsFinalMeasurementImg)
    };
    return this._http.get<ComponentImageListVm>('api/WSRE/GetObspointPhotoListWSREFrame', options).pipe(catchError(this.handleError));
  }


  public getObsPointframePhotoList(inspectionDetailId: number, inspectionId: number, Side: number,IsFinalMeasurementImg:boolean): Observable<ComponentImageListVm> {
    const options = {
      params: new HttpParams().set('inspectionDetailId', inspectionDetailId.toString()).set('inspectionId', inspectionId.toString())
      .set('Side', Side.toString()).set('IsFinalMeasurmentImage', IsFinalMeasurementImg)
    }; 
    return this._http.get<ComponentImageListVm>('api/WSRE/GetObsPointframePhotoList', options).pipe(catchError(this.handleError));
  }


  public AddWSREFrameComponentImages(photo: AddWSREFrameComponentPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/WSRE/AddWSREFrameComponentImages', photo).pipe(catchError(this.handleError));
  }

  public UpdateWSREFrameObspointPhotoNew(photo: AddWSREFrameComponentPhotoModel): Observable<Tuple> {
    return this._http.post<Tuple>('api/WSRE/UpdateWSREFrameObspointPhoto', photo).pipe(catchError(this.handleError));
  }
  private handleError(error: Response) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }
  // TT-9006 service created to delete wsre frame obs image
  public DeleteFrameObsImage(photoId: number, screenId: number): Observable<boolean> {
    const options = {
      params: new HttpParams().set('photoId', photoId.toString()).set('screenId', screenId.toString())
    };
    return this._http.get<boolean>("api/WSRE/DeleteFrameObsImage", options).pipe(catchError(this.handleError));
  }

  updateWSREFrameConfigurationNEW(request: UpdateTrackFrameConfigurationRequest): Observable<UpdateTrackFrameConfigurationResponse> {
    let params = new HttpParams()
      .set('WsreId', request.WsreId.toString())
      .set('SelectedValue', request.SelectedValue.toString())
      .set('Type', request.Type.toString())
      .set('SystemInspectedSide', request.SystemInspectedSide.toString());
    return this._http.post<UpdateTrackFrameConfigurationResponse>('api/WSRE/UpdateWSREFrameConfigurationNEW', params).pipe(catchError(this.handleError));
  }

  getActionHistory(systemIds: string, screenId: number, moduleId: number, pageNumber: number, pageSize: number, systemUpdates: boolean = true, componentRepairs: boolean = true, componentMeasurementUpdates: boolean = false): Observable<PagedResult<WSREActionHistoryVM>> {
    const options = {
      params: new HttpParams().set('systemIds', systemIds.toString()).set('screenId', screenId.toString()).set('moduleId', moduleId.toString())
        .set('pageNumber', pageNumber.toString()).set('pageSize', pageSize.toString())
        .set('SystemUpdates', systemUpdates.toString())
        .set('ComponentRepairs', componentRepairs.toString())
        .set('ComponentMeasurementUpdates', componentMeasurementUpdates.toString())
    };
    return this._http.get<PagedResult<WSREActionHistoryVM>>('api/WSRE/GetSystemActionHistories', options).pipe(catchError(this.handleError));
  }

  getAuditLogHistory(equipmentId: number, screenId: number, moduleId: number, pageNumber: number, pageSize: number): Observable<PagedResult<WSREActionHistoryVM>> {
    const options = {
      params: new HttpParams().set('EquipmentId', equipmentId.toString()).set('ScreenId', screenId.toString()).set('ModuleId', moduleId.toString())
        .set('PageNumber', pageNumber.toString()).set('PageSize', pageSize.toString())
    };
    return this._http.get<PagedResult<WSREActionHistoryVM>>('api/WSRE/GetAuditLogHistory', options).pipe(catchError(this.handleError));
  }


}
